var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_22662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.34393 7.63125C2.49145 8.75665 3.04406 9.78971 3.89833 10.5371C4.75259 11.2844 5.84995 11.6948 6.98497 11.6914C8.11999 11.688 9.21487 11.2711 10.0647 10.5186C10.9144 9.76618 11.4609 8.72983 11.6016 7.60357C11.7424 6.4773 11.4679 5.33834 10.8295 4.39988C10.1911 3.46141 9.23252 2.7878 8.13326 2.50512C7.03399 2.22244 5.86938 2.35007 4.85744 2.86414C3.8455 3.3782 3.0556 4.24345 2.6356 5.29791",
    stroke: "#111B48",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34609 3.89453V5.29453H3.74609",
    stroke: "#111B48",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_22662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadBlack);
export default __webpack_public_path__ + "static/media/reload-black.c50c0ff074bb2f2cca3beb4fb3d98732.svg";
export { ForwardRef as ReactComponent };